import { Button, Stack, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { urlGetCertificationById } from '../../helpers';
import useFetch from '../../hooks/useFetch';
import CircularProgress from '@mui/material/CircularProgress';
import './style.css';
import { ViewContactData } from '../work/components/ViewContactData';
import ViewServiceWork from '../work/components/ViewServiceWork';
import { ViewRentsWork } from '../work/components/ViewRentsWork';
import { ViewConditionWork } from '../work/components/ViewConditionWork';

export const CertificationViewData = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const { data } = useFetch(urlGetCertificationById + '?id=' + searchParams.get('id'));

    const { status, client, rents, product, work, workId } = data ? data[0] : {};

    return (
        <Stack width='100%' alignItems='center' >
            {
                data
                    ?
                    <Stack width='95%' mt='2rem' className='viewPage' pb='5rem' >
                        <Typography variant="h4" color="primary" textAlign='center'><b>Certificación de obra:</b> {work.addressWork}</Typography>
                        <ViewContactData status={status} dataContact={JSON.parse(client.contacts).filter(c => c.contactName === work.contact)[0]} />

                        <Typography variant="h6" color="primary" textAlign='center'>Condiciones</Typography>
                        <ViewConditionWork data={work} />

                        {
                            (product !== '[]' && product !== '0') &&
                            <>
                                <Typography variant="h6" color="primary" textAlign='center'>Servicios</Typography>
                                <ViewServiceWork services={product} />
                            </>
                        }
                        {
                            (rents !== '[]' && rents !== '0') &&
                            <>
                                <Typography variant="h6" color="primary" textAlign='center'>Alquileres</Typography>
                                <ViewRentsWork rents={rents} />
                            </>
                        }

                        <Link to={`/viewWork?id=${workId}`} style={{ textDecoration: 'none', textAlign: 'center' }}><Button variant='outlined' color="primary" >Ver Obra de origen</Button></Link>

                    </Stack>
                    : <CircularProgress />
            }
        </Stack>
    )
}